import locale from "element-ui/lib/locale/lang/ru-RU";

require('../bootstrap');

import Vue from 'vue';
import Menu from './menu';
import System from './system';
import {CreateFromTimezone} from "../../utils/DayJs/CreateFromTimezone";
import {ElSelectArrowFix} from "../../utils/Elements/ElSelectArrowFix";
import api from '../admin/api/api';
import Doctors from './components/doctors/Doctors.vue';
import DoctorsClinic from './components/doctors/DoctorsClinic.vue';
import DoctorsCovid from "./components/doctors/doctors-covid/DoctorsCovid";
import Review from './components/doctors/review/Review.vue';
import Schedule from './components/schedule/Schedule.vue'
import Room from "./components/consultation/Room/Room";
import RecentConsultations from "./components/widgets/recent_consultations/RecentConsultations";
import Dashboard from "./components/dashboard/Dashboard.vue";
import Consultations from "./components/consultation/Consultations";
import Clinics from "./components/clincis/Clinics";
import Balance from "./components/widgets/balance/Balance";
import TimezoneClock from "./components/widgets/clock/TimezoneClock";
import { Select, Option, Collapse, CollapseItem, Pagination, Rate, Input, Loading } from 'element-ui';
import '../../sass/front.scss';
import CitiesModal from "./components/cities/CitiesModal";
import dayjs from "dayjs";

Vue.use(Select, {locale});
Vue.use(Option, {locale});
Vue.use(Collapse, {locale});
Vue.use(CollapseItem, {locale});
Vue.use(Pagination, {locale});
Vue.use(Rate, {locale});
Vue.use(Input, {locale});
Vue.use(ElSelectArrowFix);
Vue.use(CreateFromTimezone);
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;

new Vue({
	el: '#app',
	components: {
		Doctors,
        DoctorsCovid,
        Clinics,
        Room,
		Schedule,
		Dashboard,
        RecentConsultations,
        Consultations,
        DoctorsClinic,
        Balance,
        Review,
        TimezoneClock,
        CitiesModal,
    },
    directives: {
        init: {
            bind: function(el, binding, vnode) {
                vnode.context[binding.arg] = binding.value;
            }
        }
    },
    data: {
		params: {
			familyType: [],
			profileAvatar: null,
			showCancelAppointment: 0,
			partnerType: null,
            imageErrors: {},
            licenseErrors: {},
            license: null,
            specialties: [],
            doctorSpecialties: null,
            showProfilePayment: false,
            city: null,
            cities: [],
            userTimeZone: window.laravel.userTimeZone ? window.laravel.userTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone,
            covidFlag: false
        },
        partner: '',
	},
	mounted: function () {
	    this.$elSelectArrowFix();

		this.params.familyType = window.laravel.familyType;
		this.params.profileAvatar = window.laravel.profileAvatar;
		this.params.license = window.laravel.license;
		this.params.specialties = window.laravel.specialties;
		this.params.doctorSpecialties = window.laravel.doctorSpecialties;
        this.params.showProfilePayment = window.laravel.showProfilePayment;
        this.params.city = window.laravel.city;
        this.params.cities = window.laravel.cities;

        if (window.laravel.psychoIds) {
            this.psychoIds = window.laravel.psychoIds;
            this.changeSpecialties();
        }
    },
	methods: {
		loadAvatar($event) {
		    if (!$event.target.files.length) {
		        return false;
            }

            let imageForm = new FormData();

            imageForm.append('image', this.$refs.myAvatar.files[0]);

            api.post('/api/image/preview', imageForm,  {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.params.imageErrors = {};

                this.params.profileAvatar = response.data.image;
            }).catch(error => {
                this.params.imageErrors = error.response.data.errors.image;
            });
		},
        loadLicense($event) {
            if (!$event.target.files.length) {
                return false;
            }

            if (this.$refs.license.files[0].size / 1024 > 9000) {
                this.params.license = null;
                this.params.licenseErrors = ['Размер файла в поле "Лицензия" не может быть более 9000 Килобайт(а)'];
                return false;
            }
            let imageForm = new FormData();

            imageForm.append('license', this.$refs.license.files[0]);

            api.post('/api/file/license', imageForm,  {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(response => {
                this.params.licenseErrors = {};
                this.params.license = null;
                this.params.license = response.data.license;
            }).catch(error => {
                this.params.licenseErrors = error.response.data.errors.license;
            });
		},
		showCancelAppointment(id) {
			this.params.showCancelAppointment = id;
		},
		hideCancelAppointment() {
			this.params.showCancelAppointment = 0;
		},
        switchProfilePayment() {
		    this.params.showProfilePayment = false;
        },
        getTimeZone() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        },
        changeTimeZone($event) {
            this.params.userTimeZone = $event.target.value;
        },
        convertToTimeZone(time) {
            return dayjs.createFromTimezone(time, this.params.userTimeZone);
        },
        redirectToDashboard() {
		    window.location.href = '/account/dashboard';
        },
        changeSpecialties($event){
            this.params.covidFlag = false;

		    _.forEach(this.psychoIds, (id) => {
                 if (this.params.doctorSpecialties.includes(id)) this.params.covidFlag = true;
            });
        }
	},
});
